import axios from 'axios'

export default {
  upload(file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post( '/api/file/upload',
      formData,
      {
        onUploadProgress: (progressEvent) => {
             const total = progressEvent.total
            const totalLenght = progressEvent.total.length
            console.log(total, totalLenght)
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
    );
  },
  download(id) {
    return axios.get(`/api/file/download?id=${id}`, { responseType: 'blob' });
  },
  downloadByUid(uid) {
    return axios.get(`/api/file/downloadByGuid?guid=${uid}`, { responseType: 'blob' });
  }
}